'use strict';

wbApp.factory('activityReconciliationSvc', ['$resource', '$q', '$translate', 'repositorySvc', 'notificationSvc', 'tenantSettingSvc',
function ($resource, $q, $translate, repositorySvc, notificationSvc, tenantSettingSvc) {

    var ActivityReconciliations = $resource('/Api/ActivityReconciliations/:id', {}, {
        'getStudentsByActivity': { method: 'GET', isArray: true, url: '/Api/ActivityReconciliations/GetStudentsByActivity' },
        'getStudentsAttendanceByActivity': { method: 'GET', isArray: true, url: '/Api/ActivityReconciliations/GetStudentsAttendanceByActivity' },
        'getByStudentAndActivity': { method: 'GET', isArray: true, url: '/Api/ActivityReconciliations/GetByStudentAndActivity' },
        'getReconciliationDetail': { method: 'GET', isArray: false, url: '/Api/ActivityReconciliations/GetReconciliationDetail' },
        'insertReconciliationDetail': { method: 'POST', url: '/Api/ActivityReconciliations/InsertReconciliationDetail' },
        'updateReconciliationDetail': { method: 'POST', url: '/Api/ActivityReconciliations/UpdateReconciliationDetail' },
        'deleteReconciliationDetail': { method: 'POST', url: '/Api/ActivityReconciliations/DeleteReconciliationDetail' },
        'sendReconciliationNotification': { method: 'POST', url: '/Api/ActivityReconciliations/SendReconciliationNotification' },
        'getAvailableExuses': { method: 'GET', url: '/Api/ActivityReconciliations/GetAvailableExuses' }
    });

    function refreshByStudentAndActivity(students, studentID, semesterID, activityID, reconciliationDataRange, fromDate, toDate) {
        var res = repositorySvc.customGet('getStudentsByActivity', ActivityReconciliations, {
            semesterID: semesterID,
            activityID: activityID,
            fromDate: reconciliationDataRange === 2 ? fromDate : null,
            toDate: reconciliationDataRange === 2 ? toDate : null
        });

        res.$promise.then(function (data) {
            var newStudent = null;
            var oldStudent = null;

            for (var i = 0; i < data.length; i++) {
                var s = data[i];
                if (s["studentID"] === studentID) {
                    newStudent = s;
                    break;
                }
            }

            for (var i = 0; i < students.length; i++) {
                var s = students[i];
                if (s["studentID"] === studentID) {
                    oldStudent = s;
                    break;
                }
            }

            // Update properties
            if (oldStudent && newStudent) {
                for (var p in newStudent) {
                    oldStudent[p] = newStudent[p];
                }
            }
        });
    }

    function getStudentsByActivity(semesterID, activityID, reconciliationDataRange, fromDate, toDate) {
        return repositorySvc.customGet('getStudentsByActivity', ActivityReconciliations, {
            semesterID: semesterID,
            activityID: activityID,
            fromDate: reconciliationDataRange === 2 ? fromDate : null,
            toDate: reconciliationDataRange === 2 ? moment(toDate).endOf('day').toDate() : null
        });
    }

    function getReconciliationDetail(activityID, studentID, activityReconciliationID) {
        var deferred = $q.defer();
        var result = new webooker_acivity_models.Reconciliation($translate, tenantSettingSvc.settings.calcSnacksOnlyForPresent);
        result.$promise = deferred.promise;

        repositorySvc.customGet('getReconciliationDetail', ActivityReconciliations, {
            activityID: activityID,
            studentID: studentID,
            activityReconciliationID: activityReconciliationID
        }).$promise.then(succes, error);

        function succes(data) {
            result.initData.call(result, data);
            //if (!activityReconciliationID) {
            //    setUpDefaultUnitPrices(result);
            //}
            deferred.resolve(result);
        }

        function error(errorResult) {
            deferred.reject(errorResult);
        }

        return result;
    }

    //function setUpDefaultUnitPrices(data) {
    //    if (data.activity && data.activity.defaultLunchPrice) {
    //        data.invoiceLineKindergartenLunchUnitPrice = data.activity.defaultLunchPrice;
    //    } else if (localStorageService.isSupported) {
    //        data.invoiceLineKindergartenLunchUnitPrice = localStorageService.get('lastKindergartenLunchUnitPrice');
    //    }

    //    if (data.activity && data.activity.defaultSnackPrice) {
    //        data.invoiceLineKindergartenSnackUnitPrice = data.activity.defaultSnackPrice;
    //    } else if (localStorageService.isSupported) {
    //        data.invoiceLineKindergartenSnackUnitPrice = localStorageService.get('lastKindergartenSnackUnitPrice');
    //    }

    //    if (data.activity && data.activity.defaultLatePickupPrice) {
    //        data.invoiceLineKindergartenLatePickupUnitPrice = data.activity.defaultLatePickupPrice;
    //    } else if (localStorageService.isSupported) {
    //        data.invoiceLineKindergartenLatePickupUnitPrice = localStorageService.get('lastKindergartenLatePickupUnitPrice');
    //    }
    //}

    //function saveDefaultUnitPrices(data) {
    //    if (localStorageService.isSupported) {
    //        localStorageService.set('lastKindergartenLunchUnitPrice', data.invoiceLineKindergartenLunchUnitPrice);
    //        localStorageService.set('lastKindergartenSnackUnitPrice', data.invoiceLineKindergartenSnackUnitPrice);
    //        localStorageService.set('lastKindergartenLatePickupUnitPrice', data.invoiceLineKindergartenLatePickupUnitPrice);
    //    }
    //}

    function getStudentsAttendanceByActivity(semesterID, activityID, studentID) {

        var deferred = $q.defer();
        var result = [];
        result.$promise = deferred.promise;

        repositorySvc.customGet('getStudentsAttendanceByActivity', ActivityReconciliations, {
            semesterID: semesterID,
            activityID: activityID,
            studentID: studentID
        }).$promise.then(function (data) {
            var m = [];
            for (var i = 0; i < data.length; i++) {
                var model = data[i];
                var vm = new webooker_acivity_models.ReconciliationAttendance(model);
                m.push(vm);
            }

            result.push.apply(result, m);

            deferred.resolve(result);
        }, function (errorResult) {
            deferred.reject(errorResult);
        });

        return result;
    }

    function getByStudentAndActivity(semesterID, activityID, studentID) {
        return repositorySvc.customGet('getByStudentAndActivity', ActivityReconciliations, {
            semesterID: semesterID,
            activityID: activityID,
            studentID: studentID
        });
    }

    function getAvailableExuses(activityID, studentID) {
        return repositorySvc.customGet('getAvailableExuses', ActivityReconciliations, {
            activityID: activityID,
            studentID: studentID
        });
    }

    function getMinDateRange(attendance) {
        if (attendance && attendance.length > 0) {
            for (var a = 0; a < attendance.length; a++) {
                var att = attendance[a];

                if (!att.reconciled) {
                    return moment(att.date).subtract(1, 'days').startOf('day').toDate();
                }
            }            
        }
        return null;
    }

    function getMaxDateRange(attendance) {
        if (attendance && attendance.length > 0) {
            for (var a = attendance.length - 1; a >= 0; a--) {
                var att = attendance[a];
                if (!att.reconciled) {
                    return moment(att.date).endOf('day').toDate();
                }
            }
        }

        return null;
    }

    function getToDateRange(attendance, fromDate, maxDate) {

        var from = moment(fromDate);
        var current = from;
        var endOfMonth = from.endOf('month');
        var to = endOfMonth.isBefore(maxDate)
            ? endOfMonth
            : moment(maxDate);

        if (attendance && attendance.length > 0) {
            for (var a = 0; a < attendance.length; a++) {
                var att = attendance[a];
                if (to.isBefore(att.date)) {
                    return current.endOf('day').toDate();
                }
                if (!att.reconciled) {
                    current = moment(att.date);
                }
            }


            var lastAtt = attendance[attendance.length - 1];
            if (!lastAtt.reconciled) {
                return moment(lastAtt.date).endOf('day').toDate();
            }
        }

        return null;
    }
    
    function selectDateRange(attendance, startDate, endDate) {

        let mStartDate = moment(startDate).subtract(1, 'day').startOf('day');
        let mEndDate = moment(endDate).add(1, 'day').startOf('day');

        for (let a = 0; a < attendance.length; a++) {
            let at = attendance[a];
            let mAtDate = moment(at.date).startOf('day');

            if (mAtDate.isAfter(mStartDate) && mAtDate.isBefore(mEndDate)) {
                if (at.reconciled) {
                    continue;
                }

                at.isSelected = true;
            } else {
                at.isSelected = false;
            }

        }
    }

    function insertReconciliationDetail(reconciliation, notifyClients, successCallback, errorCallback) {
        ActivityReconciliations.insertReconciliationDetail({
            reconciliationDetail: reconciliation.getReconciliationDetailDTO.call(reconciliation, $translate),
            notifyClients: notifyClients
        }, success, error);

        function success(successResult) {
          //  saveDefaultUnitPrices(reconciliation);
            repositorySvc.defaultSuccessSaveHandler(successResult, successCallback);
        }

        function error(errorResult) {
            repositorySvc.defaultErrorHandler(errorResult, errorCallback);
        }
    }

    function updateReconciliationDetail(reconciliation, notifyClients, successCallback, errorCallback) {
        ActivityReconciliations.updateReconciliationDetail({
            reconciliationDetail: reconciliation.getReconciliationDetailDTO.call(reconciliation, $translate),
            notifyClients: notifyClients
        }, success, error);

        function success(successResult) {
            //saveDefaultUnitPrices(reconciliation);
            repositorySvc.defaultSuccessSaveHandler(successResult, successCallback);
        }

        function error(errorResult) {
            repositorySvc.defaultErrorHandler(errorResult, errorCallback);
        }
    }

    function deleteReconciliationDetail(activityID, studentID, activityReconciliationID, successCallback, errorCallback) {
        ActivityReconciliations.deleteReconciliationDetail({
            activityID: activityID,
            studentID: studentID,
            activityReconciliationID: activityReconciliationID,
            notifyclients: false
        }, success, error);

        function success(successResult) {
            repositorySvc.defaultSuccessRemoveHandler(successResult, successCallback);
        }

        function error(errorResult) {
            repositorySvc.defaultErrorHandler(errorResult, errorCallback);
        }
    }

    function sendReconciliationNotification(activityID, studentID, activityReconciliationID, invoiceID, successCallback, errorCallback) {
        ActivityReconciliations.sendReconciliationNotification({
            activityID: activityID,
            studentID: studentID,
            activityReconciliationID: activityReconciliationID,
            invoiceID: invoiceID
        }, success, error);

        function success(successResult) {

            notificationSvc.notifyInfo(
                $translate.instant('TXT_ALERT_NOTIFICATION_SENT_SUCCESS'));

            if (successCallback) {
                successCallback(successResult);
            }
        }

        function error(errorResult) {
            repositorySvc.defaultErrorHandler(errorResult, errorCallback);
        }
    }

    function getReconciliationName(from, to) {
        return moment(from).format("MMMM YYYY");
    }

    return {
        getStudentsByActivity: getStudentsByActivity,
        getStudentsAttendanceByActivity: getStudentsAttendanceByActivity,
        getByStudentAndActivity: getByStudentAndActivity,
        getMinDateRange: getMinDateRange,
        getMaxDateRange: getMaxDateRange,
        selectDateRange: selectDateRange,
        getToDateRange: getToDateRange,
        getReconciliationDetail: getReconciliationDetail,
        insertReconciliationDetail: insertReconciliationDetail,
        updateReconciliationDetail: updateReconciliationDetail,
        deleteReconciliationDetail: deleteReconciliationDetail,
        getReconciliationName: getReconciliationName,
        sendReconciliationNotification: sendReconciliationNotification,
        refreshByStudentAndActivity: refreshByStudentAndActivity,
        getAvailableExuses: getAvailableExuses
    }

}]);
